import React, { useEffect, useState } from 'react';

import { VuplexInstance, WindowWithVuplex } from './types/Vuplex';
import { VuplexEventNotificationForwarder } from './VuplexEventNotificationForwarder';
import { VuplexSendMessageRequestForwarder } from './VuplexSendMessageRequestForwarder';

type TProps = {
    setIsLoaded: React.Dispatch<React.SetStateAction<boolean>>;
};

export const VuplexIntegration = (props: React.PropsWithChildren<TProps>) => {
    const [vuplexInstance, setVuplexInstance] = useState<VuplexInstance>();

    useEffect(() => {
        const onVuplexReady = () => {
            setVuplexInstance((window as unknown as WindowWithVuplex).vuplex);

            props.setIsLoaded(true);
        };

        if ((window as unknown as WindowWithVuplex).vuplex) {
            onVuplexReady();
            return;
        }

        window.addEventListener('vuplexready', onVuplexReady);

        return () => {
            window.removeEventListener('vuplexready', onVuplexReady);
        };
    }, []);

    return (
        <>
            <VuplexSendMessageRequestForwarder vuplexInstance={vuplexInstance}></VuplexSendMessageRequestForwarder>
            <VuplexEventNotificationForwarder vuplexInstance={vuplexInstance}></VuplexEventNotificationForwarder>
            {props.children}
        </>
    );
};
